import React, { useEffect } from 'react';

import { defaultStepTrigger, formatStepTrigger } from '@sopranodesign/pulse-demo';

import { BankContext } from '../Contexts/index';
import { useBankReducer } from '../reducers/index';
import { useBuilder } from '../hooks/index';

const BankProvider = ({ children }) => {
  const { conversation } = useBuilder();

  const bank = useBankReducer({
    show: localStorage.getItem('show_bank')
      ? JSON.parse(localStorage.getItem('show_bank'))
      : false,
    demo_trigger: formatStepTrigger({
      ...defaultStepTrigger,
      step_id: conversation.entry_step.id
    })
  });

  useEffect(() => {
    localStorage.setItem('show_bank', JSON.stringify(bank.bank.show));
  }, [bank.bank]);

  useEffect(() => {
    bank.dispatch({
      type: 'TEST_STEP',
      demoTrigger: formatStepTrigger({
        ...defaultStepTrigger,
        step_id: conversation.entry_step.id
      })
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversation.entry_step.id]);

  return <BankContext.Provider value={bank}>{children}</BankContext.Provider>;
};

export default BankProvider;
